import { render, staticRenderFns } from "./NavbarLogin.vue?vue&type=template&id=6455454e&"
import script from "./NavbarLogin.vue?vue&type=script&lang=js&"
export * from "./NavbarLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports